"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyCreatePodcastV1ProjectsPodcastCreatePost = void 0;
const core = __importStar(require("../../core"));
const BodyCreatePodcastV1ProjectsPodcastCreatePostMode_1 = require("./BodyCreatePodcastV1ProjectsPodcastCreatePostMode");
const BodyCreatePodcastV1ProjectsPodcastCreatePostSource_1 = require("./BodyCreatePodcastV1ProjectsPodcastCreatePostSource");
const BodyCreatePodcastV1ProjectsPodcastCreatePostQualityPreset_1 = require("./BodyCreatePodcastV1ProjectsPodcastCreatePostQualityPreset");
const BodyCreatePodcastV1ProjectsPodcastCreatePostDurationScale_1 = require("./BodyCreatePodcastV1ProjectsPodcastCreatePostDurationScale");
exports.BodyCreatePodcastV1ProjectsPodcastCreatePost = core.serialization.object({
    modelId: core.serialization.property("model_id", core.serialization.string()),
    mode: BodyCreatePodcastV1ProjectsPodcastCreatePostMode_1.BodyCreatePodcastV1ProjectsPodcastCreatePostMode,
    source: BodyCreatePodcastV1ProjectsPodcastCreatePostSource_1.BodyCreatePodcastV1ProjectsPodcastCreatePostSource,
    qualityPreset: core.serialization.property("quality_preset", BodyCreatePodcastV1ProjectsPodcastCreatePostQualityPreset_1.BodyCreatePodcastV1ProjectsPodcastCreatePostQualityPreset.optional()),
    durationScale: core.serialization.property("duration_scale", BodyCreatePodcastV1ProjectsPodcastCreatePostDurationScale_1.BodyCreatePodcastV1ProjectsPodcastCreatePostDurationScale.optional()),
    language: core.serialization.string().optional(),
    intro: core.serialization.string().optional(),
    outro: core.serialization.string().optional(),
    instructionsPrompt: core.serialization.property("instructions_prompt", core.serialization.string().optional()),
    highlights: core.serialization.list(core.serialization.string()).optional(),
    callbackUrl: core.serialization.property("callback_url", core.serialization.string().optional()),
});
